import { render, staticRenderFns } from "./AllCameVehicle.vue?vue&type=template&id=7963a4ab&scoped=true&"
import script from "./AllCameVehicle.vue?vue&type=script&lang=js&"
export * from "./AllCameVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AllCameVehicle.vue?vue&type=style&index=0&id=7963a4ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963a4ab",
  null
  
)

export default component.exports